import React, { useState } from 'react'
import InstructionBox from './InstructionBox'
import { useIsDesktop, useIsTablet } from '../../../hooks/breakpoints'
import cowinImage from '../../../images/co-win.png'
import useTranslation from '../../../hooks/use-translation'
import Input from '../../VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm'
import { TextField } from '@material-ui/core'
import { srStoreCowinInfo } from '../../../sources/book-appointments'
import lodash from 'lodash'
import { parseQueryString } from '../../../utils/utils'
import { CircularProgress, Snackbar } from '@material-ui/core'
import config from '../../../config.json'
import SnackbarMy from './Snackbar'

const styles = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    margin: '1em',
    marginBottom: '6em',
    padding: '1em'
  },
  container: {
    width: '769px',
    // height: '700px',
    border: '1px solid #CBCBCB'
  },
  mobileContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    alignContent: 'center'
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '2em'
  },
  rightContainer: {
    width: '350px',
    // height: '661px',
    border: '1px solid #CBCBCB',
    marginLeft: '2em'
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '2em'
  },
  formDetailContainer: {
    background: '#F7F7F7',
    padding: '1em'
  },
  headerTxt: {
    fontFamily: 'JioType-Medium',
    fontSize: '18px',
    color: '#333333',
    marginBottom: '1em'
  },
  headerSubTxt: {
    fontFamily: 'JioType-Medium',
    fontSize: '16px',
    color: '#666666',
    marginBottom: '1em'
  },
  bottomContainer: {
    paddingLeft: '2em',
    width: '529px',
    paddingBottom: '2em'
  },
  bottomHeader: {
    fontFamily: 'JioType-Medium',
    fontSize: '18px',
    color: '#333333'
  },
  bottomHeaderTxt: {
    fontFamily: 'JioType-Medium',
    fontSize: '14px',
    color: '#666666',
    marginBottom: '1em'
  },
  clickLink: {
    color: '#034EA1',
    textDecoration: 'underline',
    outline: 'none',
    border: 'none',
    background: 'none',
    padding: '0',
    cursor: 'pointer'
  },
  textfield: {
    border: '1px solid #CBCBCB',
    height: '50px',
    width: '300px',
    borderRadius: '5px',
    outline: 'none',
    textAlign: 'center',
    fontSize: '1.125rem',
    '::placeholder': {
      fontSize: '32px',
      color: 'red'
    }
  },
  textfieldDiv: {
    // marginBottom: '0.98em'
  },
  proceedBtn: {
    height: '50px',
    width: '300px',
    outline: 'none',
    background: '#3CB5EA',
    borderRadius: '5px',
    color: '#FFFFFF',
    borderStyle: 'none',
    marginTop: '1em'
  },
  errorText: {
    color: '#B00020',
    marginTop: '-0.6em',
    fontSize: '12px'
  },
  registerButton: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '0.5em'
  },
  mobiletextfield:{
    padding: '0.625em 0.625em',
    height: '30px',
    width: '283px',
    borderRadius: '5px',
    textAlign: 'center',
    background: 'white'
  },
  errorTextMobile:{
    color: '#B00020',
    marginTop: '-0.5em',
    marginLeft: '0.5em',
    textAlign: 'left',
    fontSize: '12px'
  },
  textfieldsErrorValuetyle:{
    padding: '0.625em 0.625em',
    height: '30px',
    width: '283px',
    borderRadius: '5px',
    textAlign: 'center'
  }
}

 const errorMessages = {
    'confirmReferenceId': `Reference ID and Confirm Reference ID doesn't match`, 
    'referenceId': 'Please enter Reference ID', 
    'mobileNumber': 'Please enter a valid 10-digit mobile number', 
    'userName': 'Please enter valid characters in the name' 
  }

export default (props) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const params = parseQueryString()
  const name = atob(lodash.get(params, "t", ''))
  const [openInstructionBox, setOpenInstructionBox] = useState(false)
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [fieldValues, setFieldValues] = useState({
    referenceId: '',
    confirmReferenceId: '',
    userName: name || '',
    mobileNumber: ''
  })

  const [errorValues, setErrorValues] = useState({
    referenceId: '',
    confirmReferenceId: '',
    userName: '',
    mobileNumber: ''
  })

  const isDesktop = useIsDesktop()
  const isTablet = useIsTablet()
  const { t } = useTranslation()

  const onTextChange = event => {
    const { value, id } = event.target
    setFieldValues({ ...fieldValues, [id]: value })
  }
  const validateField = (id, value) => {
    switch (id) {
      case 'referenceId':
        if(fieldValues.confirmReferenceId && fieldValues.referenceId){
          if(fieldValues.referenceId === fieldValues.confirmReferenceId){
            setErrorValues({ ...errorValues, confirmReferenceId: '', referenceId: ''})
            return
          }
          return { isError: !(fieldValues.referenceId === fieldValues.confirmReferenceId), errorMessage: `Reference ID and Confirm Reference ID doesn't match`}
        }
        return { isError: !fieldValues.referenceId, errorMessage: 'Please enter Reference ID'}
      case 'confirmReferenceId':
        if(fieldValues.confirmReferenceId && fieldValues.referenceId && fieldValues.referenceId === fieldValues.confirmReferenceId){
          setErrorValues({ ...errorValues, confirmReferenceId: '', referenceId: ''})
          return
        }
        return { isError: !fieldValues.confirmReferenceId || !(fieldValues.referenceId === fieldValues.confirmReferenceId), errorMessage: `Reference ID and Confirm Reference ID doesn't match`}
      case 'userName':
        return { isError: !fieldValues.userName || !(/^[ A-Za-z./'-]*$/).test(value), errorMessage: 'Please enter valid characters in the name'}
      case 'mobileNumber':
        return { isError: !fieldValues.mobileNumber || !(/^\d{10}$/).test(value), errorMessage: 'Please enter a valid 10-digit mobile number'}
      default: return true
    }
  }

const reqObj = {
  "cowin_mobile_no": fieldValues.mobileNumber,
  "cowin_name": fieldValues.userName,
  "reference_id": fieldValues.referenceId
}
  const callStoreDetailsApi = async () =>{
    if(loading) return
    try{
      const resp = await srStoreCowinInfo(reqObj)
      if(resp.status === 'success'){
      props.setcowinRegistration()
      }
       if(resp.apiResponse === 'failed'){
      setErrorMsg(resp?.response?.data?.message)
      setOpen(true)
      setLoading(false)
      }
      setLoading(false)
    } 
    catch(e){
      setOpen(true)
      setLoading(false)
      console.log(e, 'e')
    }
  }

  const onTextBlur = event => {
    const { value, id } = event.target
    let errorObj = validateField(id, value)
    if(errorObj){
    if(errorObj?.isError){
    setErrorValues({ ...errorValues, [id]: errorObj?.errorMessage })
    return
    }
    setErrorValues({ ...errorValues, [id]: '' })
  }
  }

  let fieldsErrorValue = {};
const setError = () =>{
  for (let [key, value] of Object.entries(fieldValues)) {
    let errorObj = validateField(key, value)
    if(errorObj){
      if(errorObj?.isError){
        fieldsErrorValue[key] = errorObj?.errorMessage
      }
      else{
        fieldsErrorValue[key] = ''
      }
    }
  }
  setErrorValues({ ...errorValues, ...fieldsErrorValue })
}

const checkAllValues = () => {
  return fieldValues.referenceId && fieldValues.confirmReferenceId && fieldValues.mobileNumber &&
  fieldValues.userName && !fieldsErrorValue.userName && !fieldsErrorValue.mobileNumber && !fieldsErrorValue.referenceId && !fieldsErrorValue.confirmReferenceId
}
  const proceedClick = () =>{
    setError()
    if(checkAllValues()){
      setLoading(true)
      return callStoreDetailsApi()
    }
    return setError()
  }
  const renderDesktop = () => {
    return (
      <div style={styles.mainContainer}>
        <div style={styles.container}>
          <div style={styles.leftContainer}>
            <div>
              <img className='cowinImage' src={cowinImage} alt='cowinImage' height='383' width='348' />
            </div>
            <div style={styles.detailsContainer}>
              <div style={styles.headerTxt}>
                {t('COWIN_HEADER')}
              </div>
              <div style={styles.headerSubTxt}>
                {t('COWIN_SUB_HEADER')}
                <div>
                  <button onClick={() => setOpenInstructionBox(true)} style={styles.clickLink}>{t('COWIN_CLICK_HERE')}</button>
                  {t('FOR_INSTRUCTION')}
                </div>
              </div>
              <div style={styles.formDetail}>
                <div style={styles.textfieldDiv}>
                  <TextField
                    value={fieldValues.referenceId}
                    margin='normal'
                    variant='outlined'
                    type='password'
                    id='referenceId'
                    autoComplete="off"
                    onChange={onTextChange}
                    onBlur={onTextBlur}
                    inputProps={{
                      style: styles.textfieldsErrorValuetyle
                    }}
                    placeholder={t('REFERENCE_ID')}
                  />
                  <div style={styles.errorText}>{errorValues.referenceId}</div>
                </div>
                <div style={styles.textfieldDiv}>
                  <TextField
                    value={fieldValues.confirmReferenceId}
                    margin='normal'
                    variant='outlined'
                    type='text'
                    autoComplete="off"
                    id='confirmReferenceId'
                    onChange={onTextChange}
                    onBlur={onTextBlur}
                    inputProps={{
                      style: styles.textfieldsErrorValuetyle
                    }}
                    placeholder={t('CONFIRM_REF_ID')}
                  />
                  <div style={styles.errorText}>{errorValues.confirmReferenceId}</div>
                </div>
                <div style={styles.textfieldDiv}>
                  <TextField
                    value={fieldValues.userName}
                    margin='normal'
                    variant='outlined'
                    type='text'
                    id='userName'
                    autoComplete="off"
                    onChange={onTextChange}
                    onBlur={onTextBlur}
                    inputProps={{
                      style: styles.textfieldsErrorValuetyle
                    }}
                    placeholder='Name'
                  />
                  <div style={styles.errorText}>{errorValues.userName}</div>
                </div>
                <div style={styles.textfieldDiv}>
                  <TextField
                    value={fieldValues.mobileNumber}
                    margin='normal'
                    variant='outlined'
                    type='tel'
                    maxLength='10'
                    id='mobileNumber'
                    autoComplete="off"
                    onChange={onTextChange}
                    onBlur={onTextBlur}
                    inputProps={{
                      maxLength:'10',
                      style: styles.textfieldsErrorValuetyle
                    }}
                    placeholder='Mobile number'
                  />
                  <div style={styles.errorText}>{errorValues.mobileNumber}</div>
                </div>
                <button style={styles.proceedBtn} onClick={proceedClick} >{!loading ? t('PROCEED') : <CircularProgress size={20} />}</button>
              </div>
            </div>
          </div>
          <hr />
          <div style={styles.bottomContainer}>
            <div style={styles.bottomHeader}>
              {t('COWIN_NOT_REGISTERED')}
            </div>
            <div style={styles.bottomHeaderTxt}>
              {t('COWIN_NOT_REGISTERED_TEXT')}
              <a style={styles.clickLink} href={config.cowinRegistrationGuideLink} target="_blank" rel="noopener noreferrer">{t('REFER_HERE')}</a>
              {t('REFER_NEXT')}
            </div>
            <Input type="button" value={t('COWIN_REGISTER_LBL')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button cowin-register-button`} onClick={() => { window.open(config.cowinRegistrationLink, "_blank") }} />
          </div>
        </div>
        <hr />
        {
          openInstructionBox && <div style={styles.rightContainer}><InstructionBox close={() => setOpenInstructionBox(false)} /></div>
        }
         <Snackbar
        anchorOrigin={{
          vertical: 'top',horizontal: 'center'
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <SnackbarMy handleClick={handleClick} handleClose={handleClose} errorMsg={errorMsg} />
      </Snackbar>
      </div>
    )
  }
 
  const renderMobile = () => {
    return (
      <div style={styles.mainContainer}>
        <div style={styles.mobileContainer}>
          <div>
            <div style={styles.headerTxt}>
              {t('COWIN_HEADER')}
            </div>
            <div>
              <img className='cowinImage' src={cowinImage} alt='cowinImage' height='143' width='137' />
            </div>
            <div style={styles.formDetailContainer}>
              <div style={{ ...styles.headerSubTxt, fontSize: '14px' }}>
                {t('COWIN_SUB_HEADER')}
                <div>
                  <button onClick={() => setOpenInstructionBox(true)} style={styles.clickLink}>{t('COWIN_CLICK_HERE')}</button>
                  {t('FOR_INSTRUCTION')}
                </div>
              </div>
              <div style={styles.formDetail}>
                <div style={styles.textfieldDiv}>
                  <TextField
                  value={fieldValues.referenceId}
                  margin='normal'
                  variant='outlined'
                  type='password'
                  id='referenceId'
                  autoComplete="off"
                  onChange={onTextChange}
                  onBlur={onTextBlur}
                  inputProps={{
                      style: styles.mobiletextfield
                    }}
                  placeholder={t('REFERENCE_ID')}
                  />
                  <div style={styles.errorTextMobile}>{errorValues.referenceId}</div>
                </div>
                <div style={styles.textfieldDiv}>
                  <TextField
                    value={fieldValues.confirmReferenceId}
                    margin='normal'
                    variant='outlined'
                    type='text'
                    id='confirmReferenceId'
                    autoComplete="off"
                    onChange={onTextChange}
                    onBlur={onTextBlur}
                    inputProps={{
                      style: styles.mobiletextfield
                    }}
                    placeholder={t('CONFIRM_REF_ID')}
                  />
                  <div style={styles.errorTextMobile}>{errorValues.confirmReferenceId}</div>
                </div>
                <div style={styles.textfieldDiv}>
                  <TextField
                    value={fieldValues.userName}
                    margin='normal'
                    variant='outlined'
                    type='text'
                    id='userName'
                    autoComplete="off"
                    onChange={onTextChange}
                    onBlur={onTextBlur}
                    inputProps={{
                      style: styles.mobiletextfield
                    }}
                    placeholder='Name'
                  />
                  <div style={styles.errorTextMobile}>{errorValues.userName}</div>
                </div>
                <div style={styles.textfieldDiv}>
                  <TextField
                    value={fieldValues.mobileNumber}
                    margin='normal'
                    variant='outlined'
                    type='tel'
                    maxLength='10'
                    id='mobileNumber'
                    autoComplete="off"
                    onChange={onTextChange}
                    onBlur={onTextBlur}
                    inputProps={{
                      maxLength:'10',
                      style: styles.mobiletextfield
                    }}
                    placeholder='Mobile number'
                  />
                  <div style={styles.errorTextMobile}>{errorValues.mobileNumber}</div>
                </div>
                <button style={styles.proceedBtn} onClick={proceedClick}>{!loading ? t('PROCEED') : <CircularProgress size={20} />}</button>
              </div>
            </div>
          </div>
          <hr style={{ marginLeft:'-2em', marginRight:'-2em' }}/>
          <div>
            <div style={styles.bottomHeader}>
              {t('COWIN_NOT_REGISTERED')}
            </div>
            <div style={styles.registerButton}>
              <Input type="button" value={t('COWIN_REGISTER_LBL')} addClassInput={`update-vaccine-details-upload-button vaccine-details-button cowin-register-button`} onClick={() => { window.open(config.cowinRegistrationLink, "_blank") }} />
            </div>
            <div style={{ ...styles.bottomHeaderTxt, fontSize: '12px' }}>
              {t('COWIN_NOT_REGISTERED_TEXT')}
              <a style={styles.clickLink} href={config.cowinRegistrationGuideLink} target="_blank" rel="noopener noreferrer">{t('REFER_HERE')}</a>
              {t('REFER_NEXT')}
            </div>
          </div>
        </div>
        {
          openInstructionBox && <div><InstructionBox close={() => setOpenInstructionBox(false)} isMobile /></div>
        }
        <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
         <SnackbarMy handleClick={handleClick} handleClose={handleClose} errorMsg={errorMsg} />
       </Snackbar>
      </div>
    )
  }

  return (
    (isDesktop || isTablet) ? renderDesktop() : renderMobile()
  )
}
